import type { FilterationType } from "../../contexts/filtersContext/FiltersContextType";
import type {
  BuildFilterStructureType,
  GetActiveFiltersType,
  GetAvailableFiltersType,
  GetFilterByKeyType,
  GetFilterValuesType,
} from "./FiltersStructureHelpersType";

export const getAvailableFilters: GetAvailableFiltersType = (
  allAvailableFilters,
  options,
) => {
  if ("excludeKeys" in options) {
    const set = new Set(options.excludeKeys);
    return allAvailableFilters.filter((f) => !set.has(f.key));
  }
  return allAvailableFilters.filter((f) => f.key === options.includeOnlyKey);
};

export const getActiveFilters: GetActiveFiltersType = (
  appliedFilters,
  availableFilters,
  ignoredFilter,
) => {
  const curTabApplied = appliedFilters.filter((applied) =>
    availableFilters.some((available) => available.key === applied.key),
  );
  return curTabApplied.filter((f) => ignoredFilter[f.key] ?? true);
};

export const getFilterByKey: GetFilterByKeyType = (activeFilters, key) => {
  return activeFilters.find((f) => f.key === key);
};

export const getFilterValues: GetFilterValuesType = (activeFilters, key) => {
  return getFilterByKey(activeFilters, key)?.values ?? [];
};

const DEFAULT_FILTRATION_TYPE: FilterationType = "equal";

export const buildFilterStructure: BuildFilterStructureType = (
  filters,
  options = { defaultFiltrationType: "equal" },
) => {
  const effectiveDefault =
    "defaultFiltrationType" in options
      ? options.defaultFiltrationType
      : DEFAULT_FILTRATION_TYPE;

  return {
    facetInputs: {
      LIST: filters.map((f) => ({
        key: f.key,
        values: f.values,
        filtration_type: f.filtration_type ?? effectiveDefault,
      })),
    },
  };
};
